export default "__VITE_ASSET__0cfe4af9__"